$(function() {
	const mySelect = document.getElementById('pl_dropdown_filter_1');
	if (mySelect)
		mySelect.addEventListener('change', function() {
			const selectedOption = mySelect.options[mySelect.selectedIndex];
			rebuildSlides(selectedOption.value);
		});

	function rebuildSlides(monthFilter) {
		for (let index = 0; index < 1000; index++) {
			var dCarousel = $('#pl_carousel_' + index + '_desktop');
			if (dCarousel.length < 1) {
				return;
			}
			var tCarousel = $('#pl_carousel_' + index + '_tablet');
			const mCarousel = $('#pl_carousel_' + index + '_mobile');
			loadSlidesByMonth(mCarousel, tCarousel, dCarousel, monthFilter);
		}
	}

	function clearCarousel(mCarousel, tCarousel, dCarousel) {
		//Clear items
		$.each(dCarousel.find('.pl_carousel_slides_wrapper_d'), function() {
			$(this).empty();
		});
		//Clear items
		$.each(tCarousel.find('.pl_carousel_slides_wrapper_t'), function() {
			$(this).empty();
		});
		//Clear items
		$.each(mCarousel.find('.carousel-inner'), function() {
			$(this).empty();
		});
		$.each(dCarousel.find('.carousel-control-next'), function() {
			$(this).hide();
		});
		$.each(dCarousel.find('.carousel-control-prev'), function() {
			$(this).hide();
		});

		$.each(dCarousel.find('.progress').children(), function() {
			$(this).css('width', '0%');
			$(this)
				.parent()
				.hide();
		});

		$.each(tCarousel.find('.progress').children(), function() {
			$(this).css('width', '0%');
			$(this)
				.parent()
				.hide();
		});

		$.each(mCarousel.find('.progress').children(), function() {
			$(this).css('width', '0%');
			$(this)
				.parent()
				.hide();
		});
	}

	function filterDesktopCarousel(dCarousel, mCarousel, monthFilter) {
		const items = mCarousel
			.find('.pl_carouselm-inner')
			.children('.carousel-inner')
			.find('.carousel-item')
			.children('.pl_cards-wrapper')
			.find('.pl_carousel_card');

		var lop = [];
		for (let i = 0; i < items.length; i++) {
			if (
				parseInt($(items[i]).data('month')) == parseInt(monthFilter) ||
				parseInt(monthFilter) == -1
			) {
				const element = $(items[i]).clone();
				lop.push(element);
			}
		}

		initDesktopTrack(dCarousel, lop, true);

		$.each(dCarousel.find('.progress').children(), function() {
			progressBarHandler(dCarousel, $(this));
		});
		updateDesktopState(dCarousel);
	}

	function filterTabletCarousel(tCarousel, mCarousel, monthFilter) {
		const items = mCarousel
			.find('.pl_carouselm-inner')
			.children('.carousel-inner')
			.find('.carousel-item')
			.children('.pl_cards-wrapper')
			.find('.pl_carousel_card');

		var titemsD = tCarousel
			.find('.pl_carousel_carousel-inner')
			.children('.carousel-inner');
		let tcitem = $('<div class="carousel-item"></div>');
		let tcwrapper = $(
			'<div class="pl_cards-wrapper pl_cards-wrapper_t"></div>'
		);
		let tcount = 0;

		lop = [];
		for (let i = 0; i < items.length; i++) {
			if (
				parseInt($(items[i]).data('month')) == parseInt(monthFilter) ||
				parseInt(monthFilter) == -1
			) {
				const element = $(items[i]).clone();
				lop.push(element);
			}
		}

		for (let i = 0; i < lop.length; i++) {
			const element = $(lop[i]);
			//for tablet
			if (i == 0) {
				tcitem.addClass('active');
				$.each(tCarousel.find('.progress').children(), function() {
					$(this)
						.parent()
						.show();
				});
			}
			if (i > 1 && i % 2 == 0) {
				tcwrapper.append(element);
				tcitem.append(tcwrapper);
				titemsD.append(tcitem);
				tcitem = $('<div class="carousel-item"></div>');
				tcwrapper = $(
					'<div class="pl_cards-wrapper pl_cards-wrapper_t"></div>'
				);
				tcwrapper.append(element.clone());
				tcount++;
			} else {
				tcwrapper.append(element);
			}
			if (i + 1 == lop.length) {
				tcitem.append(tcwrapper);
				titemsD.append(tcitem);
				tcount++;
			}
		}
		tCarousel.data('elementCurrent', 1);
		tCarousel.data('elementCount', tcount);

		var tcar = $('.pl_cards-wrapper_t');
		$.each(tcar, function() {
			$.each($(this).children(), function() {
				$(this).addClass('pl_carousel_card_t');
			});
		});

		$.each(tCarousel.find('.progress').children(), function() {
			progressBarHandler(tCarousel, $(this));
		});
	}

	function filterMobileCarousel(mCarousel, monthFilter) {
		var lop = [];
		for (let i = 0; i < mCarouselsBackUp.length; i++) {
			if (mCarousel.attr('id') == mCarouselsBackUp[i].attr('id')) {
				var cLen = mCarouselsBackUp[i]
					.find('.pl_carouselm-inner')
					.children('.carousel-inner')
					.find('.carousel-item').length;
				for (let j = 0; j < cLen; j++) {
					const element = $(
						mCarouselsBackUp[i]
							.find('.pl_carouselm-inner')
							.children('.carousel-inner')
							.find('.carousel-item')[j]
					);
					if (
						parseInt(
							element
								.children('.pl_cards-wrapper')
								.find('.pl_carousel_card')
								.data('month')
						) == parseInt(monthFilter) ||
						parseInt(monthFilter) == -1
					) {
						lop.push(element.clone());
						console.log(element);
					}
				}
			}
		}

		var itemsD = mCarousel
			.find('.pl_carouselm-inner')
			.children('.carousel-inner');
		let count = 0;
		for (let i = 0; i < lop.length; i++) {
			const element = $(lop[i]);
			itemsD.append(element);
			if (i == 0) {
				$.each(mCarousel.find('.progress').children(), function() {
					$(this)
						.parent()
						.show();
				});
				element.addClass('active');
			} else {
				element.removeClass('active');
			}
			count++;
		}

		mCarousel.data('elementCurrent', 1);
		mCarousel.data('elementCount', count);

		$.each(mCarousel.find('.progress').children(), function() {
			progressBarHandler(mCarousel, $(this));
		});
	}

	function loadSlidesByMonth(mCarousel, tCarousel, dCarousel, monthFilter) {
		clearCarousel(mCarousel, tCarousel, dCarousel);

		filterMobileCarousel(mCarousel, monthFilter);
		filterDesktopCarousel(dCarousel, mCarousel, monthFilter);
		filterTabletCarousel(tCarousel, mCarousel, monthFilter);

		var mProgressBar = mCarousel.find('.progress').children().first();
		initMobileTrack(mCarousel, mProgressBar);
	}

	function progressBarHandler(carousel, progressBar) {
		var count = parseInt(carousel.data('elementCount') || '1');
		var current = parseInt(carousel.data('elementCurrent') || '0');
		if (count > 0) progressBar.css('width', (current / count) * 100 + '%');
		else if (count == 0) {
			progressBar.css('width', '100%');
		} else {
			progressBar.css('width', '0%');
		}
	}

	function updateMobileState(mCarousel) {
		var track = mCarousel
			.find('.pl_carouselm-inner')
			.children('.carousel-inner');

		if (!track.length) return;

		var items = track.children('.carousel-item');
		var count = items.length;

		if (count === 0) {
			mCarousel.data('elementCurrent', 0);
			mCarousel.data('elementCount', 0);
			return;
		}

		var trackElement = track.get(0);
		var scrollLeft = trackElement.scrollLeft;
		var closestIndex = 0;
		var closestDistance = Infinity;

		items.each(function(index) {
			var distance = Math.abs(this.offsetLeft - scrollLeft);

			if (distance < closestDistance) {
				closestDistance = distance;
				closestIndex = index;
			}
		});

		mCarousel.data('elementCurrent', closestIndex + 1);
		mCarousel.data('elementCount', count);

		var progressBar = mCarousel.data('progressBar');
		if (progressBar && progressBar.length) {
			progressBarHandler(mCarousel, progressBar);
		}
	}

	function initMobileTrack(mCarousel, progressBar) {
		var track = mCarousel
			.find('.pl_carouselm-inner')
			.children('.carousel-inner');

		if (!track.length) return;

		mCarousel.data('progressBar', progressBar);

		var items = track.children('.carousel-item');
		items.removeClass(
			'active carousel-item-next carousel-item-prev carousel-item-start carousel-item-end'
		);

		mCarousel.data('elementCurrent', items.length > 0 ? 1 : 0);
		mCarousel.data('elementCount', items.length);

		track.off('scroll.plMobileCarousel');

		var scrollTimer = null;
		track.on('scroll.plMobileCarousel', function() {
			clearTimeout(scrollTimer);
			scrollTimer = setTimeout(function() {
				updateMobileState(mCarousel);
			}, 50);
		});

		track.scrollLeft(0);

		if (progressBar && progressBar.length) {
			progressBarHandler(mCarousel, progressBar);
		}
	}

	function getDesktopMaxIndex(dCarousel) {
		var cardCount = parseInt(dCarousel.data('cardCount') || '0');
		var visibleCards = parseInt(dCarousel.data('visibleCards') || '4');

		if (cardCount <= visibleCards) {
			return 0;
		}

		return cardCount - visibleCards;
	}

	function updateDesktopState(dCarousel) {
		var track = dCarousel.find('.pl_carousel_track');
		if (!track.length) return;

		var cardCount = parseInt(dCarousel.data('cardCount') || '0');
		if (cardCount === 0) {
			dCarousel.data('elementCurrent', 0);
			dCarousel.data('elementCount', 0);
			updateDesktopNav(dCarousel);
			return;
		}

		var cardIndex = parseInt(dCarousel.data('cardIndex') || '0');
		var cardStep = parseFloat(dCarousel.data('cardStep') || '0');
		if (cardStep === 0) {
			cardStep = getDesktopCardStep(track);
			dCarousel.data('cardStep', cardStep);
		}
		var maxIndex = getDesktopMaxIndex(dCarousel);
		var elementCount = maxIndex > 0 ? maxIndex + 1 : 1;

		track.css('transform', 'translateX(' + -cardIndex * cardStep + 'px)');
		dCarousel.data('elementCurrent', elementCount > 0 ? cardIndex + 1 : 0);
		dCarousel.data('elementCount', elementCount);

		var progressBar = dCarousel.data('progressBar');
		if (progressBar && progressBar.length) {
			progressBarHandler(dCarousel, progressBar);
		}

		updateDesktopNav(dCarousel);
	}

	function updateDesktopNav(dCarousel) {
		var cardCount = parseInt(dCarousel.data('cardCount') || '0');
		var visibleCards = parseInt(dCarousel.data('visibleCards') || '4');
		var cardIndex = parseInt(dCarousel.data('cardIndex') || '0');
		var maxIndex = getDesktopMaxIndex(dCarousel);
		var prevBtn = dCarousel.find('.carousel-control-prev');
		var nextBtn = dCarousel.find('.carousel-control-next');

		if (cardCount <= visibleCards) {
			prevBtn.hide();
			nextBtn.hide();
			return;
		}

		if (cardIndex > 0) {
			prevBtn.show();
		} else {
			prevBtn.hide();
		}

		if (cardIndex < maxIndex) {
			nextBtn.show();
		} else {
			nextBtn.hide();
		}
	}

	function getDesktopCardStep(track) {
		var firstCard = track
			.children()
			.first()
			.get(0);
		if (!firstCard) return 0;

		var cardWidth = firstCard.getBoundingClientRect().width;
		var styles = window.getComputedStyle(firstCard);
		var marginRight = parseFloat(styles.marginRight || '0');

		return cardWidth + marginRight;
	}

	function initDesktopTrack(dCarousel, cards, showProgress) {
		var itemsD = dCarousel
			.find('.pl_carousel_carousel-inner')
			.children('.carousel-inner');
		var track = $('<div class="pl_carousel_track"></div>');

		itemsD.empty();

		for (let i = 0; i < cards.length; i++) {
			track.append($(cards[i]).clone());
		}

		itemsD.append(track);

		if (showProgress) {
			$.each(dCarousel.find('.progress').children(), function() {
				$(this)
					.parent()
					.show();
			});
		}

		dCarousel.data('cardCount', cards.length);
		dCarousel.data('visibleCards', 4);
		dCarousel.data('cardIndex', 0);
		dCarousel.data('cardStep', getDesktopCardStep(track));
	}

	function bindDesktopNav(dCarousel) {
		if (dCarousel.data('desktopNavBound')) return;

		var prevBtn = dCarousel.find('.carousel-control-prev');
		var nextBtn = dCarousel.find('.carousel-control-next');

		prevBtn.on('click', function(event) {
			event.preventDefault();
			event.stopImmediatePropagation();

			moveDesktop(dCarousel, -1);
		});

		nextBtn.on('click', function(event) {
			event.preventDefault();
			event.stopImmediatePropagation();

			moveDesktop(dCarousel, 1);
		});

		dCarousel.data('desktopNavBound', true);
	}

	function moveDesktop(dCarousel, delta) {
		var maxIndex = getDesktopMaxIndex(dCarousel);
		var cardIndex = parseInt(dCarousel.data('cardIndex') || '0');
		var nextIndex = Math.max(0, Math.min(cardIndex + delta, maxIndex));

		if (nextIndex === cardIndex) return;

		dCarousel.data('cardIndex', nextIndex);
		updateDesktopState(dCarousel);
	}

	function initCarousel() {
		for (let index = 0; index < 1000; index++) {
			var dCarousel = $('#pl_carousel_' + index + '_desktop');

			if (dCarousel.length < 1) return;
			var tCarousel = $('#pl_carousel_' + index + '_tablet');
			var mCarousel = $('#pl_carousel_' + index + '_mobile');

			mCarouselsBackUp.push(mCarousel.clone());

			const dProgressBar = $('#pl_' + index + '-pb');
			const tProgressBar = $('#pl_' + index + '-pb-t');
			const mProgressBar = $('#pl_' + index + '-pb-m');
			if (dCarousel) {
				dCarousel.data('progressBar', dProgressBar);
				bindDesktopNav(dCarousel);
			}
			if ($.fn.carousel) {
				tCarousel.carousel({ wrap: false });
			}
			if (tCarousel) {
				tCarousel.on('slide.bs.carousel', function(data) {
					$(this).data('elementCurrent', parseInt(data.to) + 1);
					progressBarHandler($(this), tProgressBar);
				});
			}

			loadSlides(mCarousel, tCarousel, dCarousel);
			initMobileTrack(mCarousel, mProgressBar);
			updateDesktopState(dCarousel);
		}
	}

	const mCarouselsBackUp = [];

	function backUpSlides(mCarousel) {
		const items = mCarousel
			.find('.pl_carouselm-inner')
			.children('.carousel-inner')
			.find('.carousel-item');

		for (let i = 0; i < items.length; i++) {
			const element = $(items[i]).clone();
			mSlide1BackUp.push(element);
		}
	}

	function loadSlides(mCarousel, tCarousel, dCarousel) {
		const items = mCarousel
			.find('.pl_carouselm-inner')
			.children('.carousel-inner')
			.find('.carousel-item')
			.children('.pl_cards-wrapper')
			.find('.pl_carousel_card');

		var lop = [];
		for (let i = 0; i < items.length; i++) {
			const element = $(items[i]).clone();
			lop.push(element);
		}
		initDesktopTrack(dCarousel, lop, false);

		//For tablet
		var titemsD = tCarousel
			.find('.pl_carousel_carousel-inner')
			.children('.carousel-inner');
		let tcitem = $('<div class="carousel-item"></div>');
		let tcwrapper = $(
			'<div class="pl_cards-wrapper pl_cards-wrapper_t"></div>'
		);
		let tcount = 0;

		var lop = [];
		for (let i = 0; i < items.length; i++) {
			const element = $(items[i]).clone();
			lop.push(element);
		}

		for (let i = 0; i < lop.length; i++) {
			const element = $(lop[i]);
			//for tablet
			if (i == 0) {
				tcitem.addClass('active');
			}
			if (i > 1 && i % 2 == 0) {
				tcwrapper.append(element);
				tcitem.append(tcwrapper);
				titemsD.append(tcitem);
				tcitem = $('<div class="carousel-item"></div>');
				tcwrapper = $(
					'<div class="pl_cards-wrapper pl_cards-wrapper_t"></div>'
				);
				tcwrapper.append(element.clone());
				tcount++;
			} else {
				tcwrapper.append(element);
			}
			if (i + 1 == lop.length) {
				tcitem.append(tcwrapper);
				titemsD.append(tcitem);
				tcount++;
			}
		}
		tCarousel.data('elementCurrent', 1);
		tCarousel.data('elementCount', tcount);
		mCarousel.data('elementCurrent', 1);
		mCarousel.data('elementCount', items.length);

		var tcar = $('.pl_cards-wrapper_t');
		$.each(tcar, function() {
			$.each($(this).children(), function() {
				$(this).addClass('pl_carousel_card_t');
			});
		});

		$.each(dCarousel.find('.progress').children(), function() {
			progressBarHandler(dCarousel, $(this));
		});

		$.each(tCarousel.find('.progress').children(), function() {
			progressBarHandler(tCarousel, $(this));
		});

		updateDesktopState(dCarousel);
	}
	initCarousel();
});